import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { TextType } from "../../../ui/type/TextType";
import { ComponentF, ComponentO, createElement } from "../../../ui/ui";
import { createAction } from "../../actions/Action";
import { pickupItem, wearArmor } from "../../actions/ActionItems";
import Colors from "../../Colors";
import {
  gameData,
  getItemsForPosition,
  runPlayerAction,
} from "../../GameManager";
import { isDownKey, isUpKey } from "../keyHelper";
import { ItemInfoDisplay } from "./ItemInfoDisplay";

export const PickupModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ selected: 0, id: null });

  floodFill(C.display, C.bounds, Colors.BLACK);
  let y = 0;

  C.display.draw(
    C.bounds.x,
    C.bounds.y + y + state.selected,
    ">",
    Colors.B_GREY_5,
    null
  );
  const result: ComponentO[] = [];

  const ids: number[] = [];
  const items = getItemsForPosition(gameData.player.x, gameData.player.y);
  items.forEach((item, index) => {
    if (!item.breed.furniture) {
      ids.push(item.id);
      result.push(
        createElement(
          TextType,
          { x: 1, y, w: 20, h: 1 },
          {
            title: `%c{${
              state.selected === index ? Colors.B_GREY_5 : Colors.B_GREY_3
            }}${item.breed.name}`,
          }
        )
      );
      if (index === state.selected) {
        result.push(
          createElement(
            ItemInfoDisplay,
            {
              x: 30,
              y: 0,
              w: C.bounds.w - 31,
              h: C.bounds.h - 7,
            },
            { item }
          )
        );
      }
      y += 1;
    }
  });

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + C.bounds.h - 1,
    `%c{${Colors.RED_4}} Enter %c{}Confirm %c{${Colors.RED_4}}Esc%c{} Cancel`
  );

  C.handlers.keypress = (key: string) => {
    if (isUpKey(key) && 0 < state.selected) {
      setState({ selected: state.selected - 1 });
    } else if (isDownKey(key) && state.selected < ids.length - 1) {
      setState({ selected: state.selected + 1 });
    } else if (key === "Enter") {
      runPlayerAction(
        createAction(pickupItem, gameData.player, { id: ids[state.selected] })
      );
      closeModal();
      return true;
    } else if (key === "Escape") {
      closeModal();
      return true;
    }
    return true;
  };
  return result;
};
